import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-[#0B8FD8] py-12 px-6 md:px-12">
      <div className="max-w-7xl mx-auto">
        <div className="text-center space-y-4">
          <h3 className="text-2xl font-serif text-white font-bold">
            Thank You
          </h3>
          <p className="text-white text-base">
            © 2026 Brooks & Associates Financial Services. All rights reserved.
          </p>
          <p className="text-white text-sm">
            Empowering communities through personalized financial education and solutions.
          </p>
          
          {/* Links Section */}
          <div className="flex flex-wrap justify-center gap-6 pt-4">
            <a 
              href="https://drive.google.com/file/d/15c4iwff9UfHjEQSDYaZj7VI6jbQEKuqy/view?usp=sharing"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white text-sm hover:underline transition-all duration-300"
            >
              Privacy Policy
            </a>
            <span className="text-white text-sm">|</span>
            <a 
              href="https://drive.google.com/file/d/1zOSWFIxvJC3BWuPnswSELRZzmaHTG7S4/view?usp=sharing"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white text-sm hover:underline transition-all duration-300"
            >
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
